import { defineMessages } from '@formatjs/intl';

import { Review } from '@/components/homepageRefresh/homepage/Testimonials/types';

export const messages = defineMessages({
	reviewsHeading: {
		id: 'subpage.sleep.testimonials.reviewsHeading2',
		defaultMessage: 'Join the millions of sound sleepers worldwide.',
		description: 'Heading for section showing users that love Calm',
	},
	review1Quote: {
		id: 'subpage.sleep.testimonials.review1quote',
		defaultMessage:
			'My wife and I have listened to Calm for well over 2 years. Cannot express how easy it is to fall asleep listening to this app.',
		description: 'Quote from a Calm app review',
	},
	review1Author: {
		id: 'subpage.sleep.testimonials.review1Author',
		defaultMessage: 'Sam from Louisville',
		description: 'Author of Calm app review',
	},
	review2Quote: {
		id: 'subpage.sleep.testimonials.review2quote',
		defaultMessage:
			'I have a very busy brain and can find it hard to unwind. Now a daily practice is actually so wonderful and healing for me.',
		description: 'Quote from a Calm app review',
	},
	review2Author: {
		id: 'subpage.sleep.testimonials.review2Author',
		defaultMessage: 'John from Chicago',
		description: 'Author of Calm app review',
	},
	review3Quote: {
		id: 'subpage.sleep.testimonials.review3quote',
		defaultMessage:
			'I have used my Calm app for several years now. Every night, I look forward to the peaceful place it is able to take my mind.',
		description: 'Quote from a Calm app review',
	},
	review3Author: {
		id: 'subpage.sleep.testimonials.review3Author',
		defaultMessage: 'Sylvie from Little Rock',
		description: 'Author of Calm app review',
	},
	review4Quote: {
		id: 'subpage.sleep.testimonials.review4quote',
		defaultMessage: "I've used this app every single night for years. It is THE BEST for falling asleep.",
		description: 'Quote from a Calm app review',
	},
	review4Author: {
		id: 'subpage.sleep.testimonials.review4Author',
		defaultMessage: 'Mathieu from Bend',
		description: 'Author of Calm app review',
	},
	review5Quote: {
		id: 'subpage.sleep.testimonials.review5quote',
		defaultMessage: "Whenever I'm having trouble calming my mind, I pick a story and I'm asleep in minutes.",
		description: 'Quote from a Calm app review',
	},
	review5Author: {
		id: 'subpage.sleep.testimonials.review5Author',
		defaultMessage: 'Jackson from Oakland',
		description: 'Author of Calm app review',
	},
	review6Quote: {
		id: 'subpage.sleep.testimonials.review6quote',
		defaultMessage:
			"Whether it is at the beginning of the night or if I wake up and can't get back to sleep, Calm never fails me.",
		description: 'Quote from a Calm app review',
	},
	review6Author: {
		id: 'subpage.sleep.testimonials.review6Author',
		defaultMessage: 'Elaine from Palo Alto',
		description: 'Author of Calm app review',
	},
});

export const reviews: Review[] = [
	{
		quote: messages.review1Quote,
		author: messages.review1Author,
	},
	{
		quote: messages.review2Quote,
		author: messages.review2Author,
	},
	{
		quote: messages.review3Quote,
		author: messages.review3Author,
	},
	{
		quote: messages.review4Quote,
		author: messages.review4Author,
	},
	{
		quote: messages.review5Quote,
		author: messages.review5Author,
	},
	{
		quote: messages.review6Quote,
		author: messages.review6Author,
	},
];
